// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { LlmQuotaOperationsService } from '../generated/api/llmQuotaOperations.service';

@Injectable({ providedIn: 'root' })
export class LlmQuotaOperationsClientService {
  constructor(private readonly client: LlmQuotaOperationsService) {}
  // <generated-client-wrappers:methods>
  allocations(
    query: WrapperApi.QuotaAllocationQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaAllocationPage> {
    if (!this.client)
      throw new Error('LlmQuotaOperationsService is not available');
    return this.client.llmQuotaOperationsAllocations(
      query,
      'body',
      reportProgress,
      options,
    );
  }

  funding(
    query: WrapperApi.QuotaFundingQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaFundingPage> {
    if (!this.client)
      throw new Error('LlmQuotaOperationsService is not available');
    return this.client.llmQuotaOperationsFunding(
      query,
      'body',
      reportProgress,
      options,
    );
  }

  reservations(
    query: WrapperApi.QuotaReservationQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.QuotaReservationPage> {
    if (!this.client)
      throw new Error('LlmQuotaOperationsService is not available');
    return this.client.llmQuotaOperationsReservations(
      query,
      'body',
      reportProgress,
      options,
    );
  }

  resolveUsage(
    request: WrapperApi.UsageResolutionRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.UsageResolutionReceipt> {
    if (!this.client)
      throw new Error('LlmQuotaOperationsService is not available');
    return this.client.llmQuotaOperationsResolveUsage(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  reviewUsage(
    query: WrapperApi.UsageReviewQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.UsageReviewResponse> {
    if (!this.client)
      throw new Error('LlmQuotaOperationsService is not available');
    return this.client.llmQuotaOperationsReviewUsage(
      query,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
